import { SearchCardAuthorizationForm } from 'core/tarjeta/components/SearchCardAuthorizationForm/SearchCardAuthorizationForm';
import { CardAuthorizationsSearchContext } from 'core/tarjeta/contexts/CardAuthorizationsSearchContext';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export const CardAuthorizationsSearchPage = () => {
  const { searchCardNumber, cardNumber } = useContext(CardAuthorizationsSearchContext);
  return (
    <Container>
      <Row>
        <Col>
          <SearchCardAuthorizationForm
            cardNumber={cardNumber}
            searchCardNumber={searchCardNumber}
          />
        </Col>
      </Row>
    </Container>
  );
};
